import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import ReportingTreeviewpage from "./ReportingTreeviewpage";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ borderRadius: "0px" }}
    >
      {value === index && (
        <Box sx={{ p: 0, borderRadius: "0px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ReportingLeftPane(props) {
  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate
  );
  const [value, setValue] = React.useState(0);
  const [pagesize, setPagesize] = useState(270);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (overviewstate) {
      setPagesize(295);
    } else {
      setPagesize(260);
    }
  }, [overviewstate]);

  return (
    <Box
      sx={{
        width: "218px",
        backgroundColor: "var(--SecondaryBackground)",
        borderRadius: "0px 0px 0px 0px",
        marginRight: "16px",
      }}
    >
      <Box sx={{ backgroundColor: "var(--PrimaryBackground)" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            "& .MuiTabs-indicator": { display: "none" },
            "& .Mui-selected": {
              backgroundColor: "var(--SecondaryBackground)",
              borderRadius: "0px 0px 0px 0px",
              color: "var(--LK_BrandBlue_1) !important",
              fontWeight: "700 !important",
              borderTop: "1px solid var(--HighlightedText_Stroke)",
              borderLeft: "1px solid var(--HighlightedText_Stroke)",
              borderRight: "1px solid var(--HighlightedText_Stroke)",
              borderBottom: "1px solid var(--SecondaryBackground)",
            },
            minHeight: "30px",
            marginBottom: "-1px",
          }}
        >
          <Tab
            label="Reports"
            {...a11yProps(0)}
            sx={{
              minHeight: "30px",
              height: "30px",
            }}
            style={{
              color: "var(--GreyVariation_2)",
              fontFamily: "Roboto",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "16.41px",
              textTransform: "capitalize",
              flexGrow: 0,
            }}
          />
        </Tabs>
      </Box>
      <Box
        sx={{
          width: "216px",
          border: "1px solid var(--HighlightedText_Stroke)",
          height: `calc(100vh - ${pagesize}px)`,
        }}
        style={{ overflow: "auto" }}
      >
        <CustomTabPanel value={value} index={0} style={{ overflow: "auto" }}>
          <ReportingTreeviewpage />
        </CustomTabPanel>
      </Box>
    </Box>
  );
}
